import React, { useCallback, useEffect, useState } from 'react';

import { IonItem, IonToggle } from '@ionic/react';

import { useUser } from 'auth/User';
import { useUserActive } from 'auth/User/data';
import { EventImpersonateConfig, impersonateAuth } from 'auth/impersonate';
import Select from 'components/Select';
import Typography from 'components/Typography';
import { useQueryClient } from 'query';

const ItemImpersonate = () => {
  const queryClient = useQueryClient();

  const { user } = useUser();

  const impersonated = user?.impersonatedBy;

  const [selectable, setSelectable] = useState(impersonated);

  const { data, isLoading, error } = useUserActive();

  const handleChangeSelectable = useCallback(
    ({ detail }) => {
      setSelectable(detail.checked);

      if (!detail.checked && impersonated) {
        impersonateAuth.dismissImpersonate();
      }
    },
    [impersonated]
  );

  const handleSetImpersonate = useCallback(
    (_e: any, userId: number | string) => impersonateAuth.impersonate(userId),
    []
  );

  useEffect(() => {
    const handler: EventImpersonateConfig = ({ userChanged }) => {
      if (userChanged) {
        queryClient.invalidateQueries();
      }
    };

    impersonateAuth.subscribe(handler);

    return () => impersonateAuth.unsubscribe(handler);
  }, []);

  useEffect(() => {
    setSelectable(impersonated);
  }, [impersonated]);

  return (
    <IonItem>
      <IonToggle
        slot={'start'}
        checked={selectable}
        onIonChange={handleChangeSelectable}
      />
      <Typography variant={'subtitle1'} inline={true}>
        Impersonate
      </Typography>
      <Select
        value={impersonated ? user.id : null}
        data={data}
        isLoading={isLoading}
        error={error}
        onChange={handleSetImpersonate}
        placeholder={'Select user'}
        disabled={!selectable}
        dense={true}
      />
    </IonItem>
  );
};

export default ItemImpersonate;
